import { object } from 'yup';
import { FieldType } from '@enquiryForm/types/config';
import { generateNumberSchemaObject } from '@enquiryForm/validation/fields/Number';
import { generatePhoneSchemaObject } from '@enquiryForm/validation/fields/Phone';
import { generateEmailSchemaObject } from '@enquiryForm/validation/fields/Email';
import { generateTextSchemaObject } from '@enquiryForm/validation/fields/Text';
import { generateCheckboxSchemaObject } from '@enquiryForm/validation/fields/Checkbox';
import { generateCaptchaSchemaObject } from '@enquiryForm/validation/fields/Captcha';
export const generateSchema = (fields) => {
    let returnedSchemaObject = {};
    fields.forEach((field) => {
        let fieldValidation;
        switch (field.type) {
            case FieldType.NumberInput:
                fieldValidation = generateNumberSchemaObject(field);
                break;
            case FieldType.CheckboxInput:
                fieldValidation = generateCheckboxSchemaObject(field);
                break;
            case FieldType.PhoneInput:
                fieldValidation = generatePhoneSchemaObject(field);
                break;
            case FieldType.EmailInput:
                fieldValidation = generateEmailSchemaObject(field);
                break;
            case FieldType.Captcha:
                fieldValidation = generateCaptchaSchemaObject(field);
                break;
            case FieldType.RadioInput:
            case FieldType.DropdownInput:
            case FieldType.TextInput:
            default:
                fieldValidation = generateTextSchemaObject(field);
                break;
        }
        if (fieldValidation) {
            returnedSchemaObject = {
                ...returnedSchemaObject,
                ...{ [field.name]: fieldValidation },
            };
        }
    });
    return object({ ...returnedSchemaObject });
};
